import Url from "@core/scripts/helper/url";
import fetchWithCSRF from "@core/scripts/helper/fetch-with-csrf";
import Logger from '@core/scripts/helper/logger';

const URL_PREFIX = "/ajax/reviews";

function loadReviews(shopId, styleId) {
    return loadReviewsWithoutErrorCatch(shopId, styleId).catch(e => Logger.debug({message:'Could not fetch reviews', error: e}));
}

function loadReviewsWithoutErrorCatch(shopId, styleId) {
    const url = Url.toAbsolute(`${URL_PREFIX}/load/?styleId=${styleId}&shopId=${shopId}`);
    return fetchWithCSRF(url)
        .then(toJsonOrThrow(new Error("response was not okay")))
}

function toJsonOrThrow(error) {
    return (response) => {
        if(response.ok) {
            return response.json();
        }
        throw error;
    };
}

export default {
    loadReviews,
    loadReviewsWithoutErrorCatch
}